import { format, intervalToDuration, parse } from 'date-fns';

export const formatDateString = (date: string, formatFrom: string, formatTo: string): string =>
  format(parse(date, formatFrom, new Date()), formatTo);

export const formatStringToDate = (date: string, formatFrom: string): Date =>
  parse(date, formatFrom, new Date());

export const formatSecToHours = (seconds: number): string => {
  const { days, hours, minutes, months } = intervalToDuration({ start: 0, end: seconds * 1000 });

  let h = hours || 0;

  if (days) h += days * 24;
  if (months) h += months * 30 * 24;

  const formattedHours = h && h < 10 ? `0${h}` : h;
  const formattedMinutes = minutes !== undefined && minutes < 10 ? `0${minutes}` : minutes;

  return `${formattedHours}:${formattedMinutes}`;
};
